import { Editor } from 'slate';
import type { Annotation, EditorPlugin } from '../../types/aha-editor';

export const normalizeAnnotations = (editor: Editor) => {
  if (!editor.metadata?.annotations) return;

  const annotations: Annotation[] = Object.values<Annotation | undefined>(
    editor.metadata.annotations
  ).filter(Boolean);

  for (const annotation of annotations) {
    const currentRange = annotation.range.current;
    if (!currentRange) continue;
    const { anchor, focus } = currentRange;
    try {
      Editor.node(editor, anchor);
      Editor.node(editor, focus);
    } catch (error) {
      // Node doesn't exist, remove the range from the
      // annotation
      // We need every copy of the document, including faye,
      // to apply this change so that the range is actually
      // removed and persisted to the backend.
      annotation.range.current = null;
    }
  }

  return false;
};

const AnnotationsNormalizationPlugin: EditorPlugin = {
  name: 'Annotations normalization plugin',
  metadataNormalizations: [
    {
      run: normalizeAnnotations,
    },
  ],
};

export default AnnotationsNormalizationPlugin;
